import * as React from 'react';

function CrossCountrySki(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M10.985 7.2a.783.783 0 00-.896-.183.783.783 0 00-.261.192l-4.28 4.793-.058.073a.793.793 0 00.19 1.101l3.582 2.531-1.648 4.661H3.782a.78.78 0 00-.537.216.793.793 0 00.445 1.358l.092.005h13.362c2.425 0 3.856-.735 3.856-2.368a.793.793 0 00-.213-.541.78.78 0 00-1.347.449l-.005.092c0 .41-.468.704-1.692.774l-1.552-8.951h.113l.092-.005a.78.78 0 00.493-.26.794.794 0 00.198-.524l-.006-.092a.792.792 0 00-.257-.498.78.78 0 00-.52-.2h-3.457l-1.8-2.545-.063-.077zm-.646 1.795l1.468 2.077.06.073a.783.783 0 00.577.257h2.158l1.553 8.966h-6.88l1.662-4.697.026-.091a.795.795 0 00-.314-.82l-3.346-2.364 3.037-3.4h-.001zM13.174 3c-.623 0-1.22.25-1.66.694a2.38 2.38 0 000 3.35 2.338 2.338 0 003.32 0 2.38 2.38 0 000-3.35A2.338 2.338 0 0013.174 3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CrossCountrySki;
